/**
 * ADHD Supplements Guide — Page JavaScript
 *
 * Concatenation order:
 *   1. _shared/config.js  — BZ.PRODUCTS, BZ.MARKETS, BZ.TRUST_CAROUSEL, BZ.VIDEOS, BZ.REVIEWS, BZ.ICONS
 *   2. _shared/components.js — component renderer (starRow, proofStrip, videoGrid, trustCarousel, etc.)
 *   3. LP_CONFIG (formerly inline script block 1, L414-L426)
 *   4. Product shelf (formerly inline script block 2, L1261-L1418)
 *   5. Plan Your Path (formerly inline script block 3, L1617-L1708)
 *   6. Page interactions (formerly inline script block 4, L1797-L2093)
 *       toggleAccordion + symptom checker + before/after slider (dead — exits cleanly)
 *       + buyer's checklist observer + dynamic sticky CTA + animated stat counters
 *       + scratch card (dead — canvas id not present, exits cleanly)
 */

/* ─────────────────────────────────────────────────────────────────────
   1. SHARED CONFIG  (from _shared/config.js)
   ───────────────────────────────────────────────────────────────────── */

window.BZ = window.BZ || {};

// ─── Products ────────────────────────────────────────────────────────
BZ.PRODUCTS = {
  uk: {
    elite:    { name: 'FOCUS ELITE\u2122',    shortName: 'ELITE',    price: '\u00A347', priceSub: '\u00A339.48/mo', url: 'https://www.brainzyme.com/products/brainzyme-elite', cart: 'https://brainzyme.myshopify.com/cart/31430974963790:1', purpose: 'Stress-free focus, mood & brain health' },
    pro:      { name: 'FOCUS PRO\u2122',      shortName: 'PRO',      price: '\u00A329', priceSub: '\u00A324.36/mo', url: 'https://www.brainzyme.com/products/brainzyme-professional-stronger-formula', cart: 'https://brainzyme.myshopify.com/cart/31430904086606:1', purpose: 'Strong focus, motivation & memory' },
    original: { name: 'FOCUS ORIGINAL\u2122', shortName: 'ORIGINAL', price: '\u00A318', priceSub: '\u00A315.12/mo', url: 'https://www.brainzyme.com/products/brainzyme-original-milder-formula', cart: 'https://brainzyme.myshopify.com/cart/31430979387470:1', purpose: 'Mild everyday focus & calm mood' }
  },
  de: {
    elite:    { name: 'FOCUS ELITE\u2122',    shortName: 'ELITE',    price: '\u20AC52', priceSub: '\u20AC43.68/Mo', url: 'https://www.brainzyme.de/products/brainzyme-elite', cart: 'https://brainzyme-de.myshopify.com/cart/30306895265882:1', purpose: 'Stressfreier Fokus, Stimmung & Gehirngesundheit' },
    pro:      { name: 'FOCUS PRO\u2122',      shortName: 'PRO',      price: '\u20AC31.75', priceSub: '\u20AC26.67/Mo', url: 'https://www.brainzyme.de/products/brainzyme-professional-stronger-formula', cart: 'https://brainzyme-de.myshopify.com/cart/30306895102042:1', purpose: 'Starker Fokus, Motivation & Ged\u00E4chtnis' },
    original: { name: 'FOCUS ORIGINAL\u2122', shortName: 'ORIGINAL', price: '\u20AC19.80', priceSub: '\u20AC16.63/Mo', url: 'https://www.brainzyme.de/products/brainzyme-original-milder-formula', cart: 'https://brainzyme-de.myshopify.com/cart/30306894905434:1', purpose: 'Milder Alltags-Fokus & ruhige Stimmung' }
  },
  fr: {
    elite:    { name: 'FOCUS ELITE\u2122',    shortName: 'ELITE',    price: '\u20AC52', priceSub: '\u20AC43,68/mois', url: 'https://www.brainzyme.fr/products/brainzyme-elite', cart: 'https://brainzyme-fr.myshopify.com/cart/28966093619305:1', purpose: 'Concentration sans stress, humeur & sant\u00E9 c\u00E9r\u00E9brale' },
    pro:      { name: 'FOCUS PRO\u2122',      shortName: 'PRO',      price: '\u20AC31.75', priceSub: '\u20AC26,67/mois', url: 'https://www.brainzyme.fr/products/brainzyme-professional-stronger-formula', cart: 'https://brainzyme-fr.myshopify.com/cart/28966088867945:1', purpose: 'Concentration forte, motivation & m\u00E9moire' },
    original: { name: 'FOCUS ORIGINAL\u2122', shortName: 'ORIGINAL', price: '\u20AC19.80', priceSub: '\u20AC16,63/mois', url: 'https://www.brainzyme.fr/products/brainzyme-original-milder-formula', cart: 'https://brainzyme-fr.myshopify.com/cart/28966039584873:1', purpose: 'Concentration douce au quotidien' }
  },
  us: {
    elite:    { name: 'FOCUS ELITE\u2122',    shortName: 'ELITE',    price: '$65', priceSub: '$54.60/mo', url: 'https://www.brainzyme.us/products/brainzyme-elite-3-in-1-formula', cart: 'https://brainzyme-us.myshopify.com/cart/39257034883264:1', purpose: 'Stress-free focus, mood & brain health' },
    pro:      { name: 'FOCUS PRO\u2122',      shortName: 'PRO',      price: '$40', priceSub: '$33.60/mo', url: 'https://www.brainzyme.us/products/brainzyme-professional-stronger-formula', cart: 'https://brainzyme-us.myshopify.com/cart/39256090771648:1', purpose: 'Strong focus, motivation & memory' },
    original: { name: 'FOCUS ORIGINAL\u2122', shortName: 'ORIGINAL', price: '$25', priceSub: '$21.00/mo', url: 'https://www.brainzyme.us/products/brainzyme-original-milder-formula', cart: 'https://brainzyme-us.myshopify.com/cart/39256054857920:1', purpose: 'Mild everyday focus & calm mood' }
  }
};

// ─── Market Strings ──────────────────────────────────────────────────
BZ.MARKETS = {
  uk: {
    lang: 'en',
    announce: 'FREE UK Delivery \u00A0|\u00A0 Subscribe & Save Up to 33%',
    trustBadges: [
      { icon: 'shield', label: '365-Day Returns & Exchanges' },
      { icon: 'globe',  label: 'UK & International Shipping' },
      { icon: 'flag',   label: 'Made in Scotland' }
    ],
    proofStrip: [
      '<strong>2,000+</strong> medical professionals trust Brainzyme',
      '<strong>365-day</strong> money-back guarantee',
      '<strong>GMP & HACCP</strong> certified, made in Scotland'
    ],
    disclaimer: 'Food supplements should not be used as a substitute for a varied, balanced diet and a healthy lifestyle. If you are pregnant, breastfeeding, taking medication or under medical supervision, consult a doctor before use. Do not exceed the recommended dose.',
    reviewStats: { rating: '4.8', count: '6,020+', source: 'verified reviews' },
    scratchLabel: 'Use at checkout on brainzyme.com'
  },
  de: {
    lang: 'de',
    announce: 'Kostenloser Versand nach DE \u00A0|\u00A0 Spare bis zu 33% mit Abo',
    trustBadges: [
      { icon: 'shield', label: '365-Tage-R\u00FCckgaberecht' },
      { icon: 'globe',  label: 'Versand nach DE, AT & CH' },
      { icon: 'flag',   label: 'Hergestellt in Schottland' }
    ],
    proofStrip: [
      '<strong>2.000+</strong> medizinische Fachkr\u00E4fte vertrauen Brainzyme',
      '<strong>365 Tage</strong> Geld-zur\u00FCck-Garantie',
      '<strong>GMP & HACCP</strong> zertifiziert, hergestellt in Schottland'
    ],
    disclaimer: 'Nahrungserg\u00E4nzungsmittel sind kein Ersatz f\u00FCr eine abwechslungsreiche, ausgewogene Ern\u00E4hrung und eine gesunde Lebensweise. Au\u00DFerhalb der Reichweite von Kindern aufbewahren. Die empfohlene Tagesdosis nicht \u00FCberschreiten.',
    reviewStats: { rating: '4,74', count: '970+', source: 'verifizierte Bewertungen' },
    scratchLabel: 'Beim Checkout auf brainzyme.de einl\u00F6sen'
  },
  fr: {
    lang: 'fr',
    announce: 'Livraison gratuite en FR \u00A0|\u00A0 \u00C9conomisez jusqu\u2019\u00E0 33% avec l\u2019abonnement',
    trustBadges: [
      { icon: 'shield', label: 'Retours sous 365 jours' },
      { icon: 'globe',  label: 'Livraison en France & Europe' },
      { icon: 'flag',   label: 'Fabriqu\u00E9 en \u00C9cosse' }
    ],
    proofStrip: [
      '<strong>2 000+</strong> professionnels de sant\u00E9 font confiance \u00E0 Brainzyme',
      '<strong>365 jours</strong> garantie satisfait ou rembours\u00E9',
      '<strong>GMP & HACCP</strong> certifi\u00E9, fabriqu\u00E9 en \u00C9cosse'
    ],
    disclaimer: 'Les compl\u00E9ments alimentaires ne remplacent pas une alimentation vari\u00E9e et \u00E9quilibr\u00E9e ni un mode de vie sain. Ne pas d\u00E9passer la dose journali\u00E8re recommand\u00E9e.',
    reviewStats: { rating: '4,74', count: '604+', source: 'avis v\u00E9rifi\u00E9s' },
    scratchLabel: 'Utilisez ce code sur brainzyme.fr'
  },
  us: {
    lang: 'en',
    announce: 'FREE US Shipping \u00A0|\u00A0 Subscribe & Save Up to 33%',
    trustBadges: [
      { icon: 'shield', label: '365-Day Returns & Exchanges' },
      { icon: 'globe',  label: 'Free US Shipping' },
      { icon: 'flag',   label: 'Made in Scotland, UK' }
    ],
    proofStrip: [
      '<strong>2,000+</strong> medical professionals trust Brainzyme',
      '<strong>365-day</strong> money-back guarantee',
      '<strong>GMP & HACCP</strong> certified, made in Scotland'
    ],
    disclaimer: 'These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.',
    reviewStats: { rating: '4.8', count: '6,020+', source: 'verified reviews' },
    scratchLabel: 'Use at checkout on brainzyme.com'
  }
};

// ─── Trust Carousel Items ────────────────────────────────────────────
BZ.TRUST_CAROUSEL = {
  en: [
    { num: '4.8/5',    label: 'Average Rating' },
    { num: '6,020+',    label: 'Verified Reviews' },
    { num: '2,000+',    label: 'Medical Professionals' },
    { num: '365-Day',   label: 'Money-Back Guarantee' },
    { num: 'GMP',       label: 'Certified Manufacturing' },
    { num: '100%',      label: 'Plant-Powered & Vegan' },
    { num: 'Made in',   label: 'Scotland, UK' }
  ],
  de: [
    { num: '4,74/5',    label: 'Durchschnittsbewertung' },
    { num: '970+',      label: 'Verifizierte Bewertungen' },
    { num: '2.000+',    label: 'Medizinische Fachkr\u00E4fte' },
    { num: '365 Tage',  label: 'Geld-zur\u00FCck-Garantie' },
    { num: 'GMP',       label: 'Zertifizierte Herstellung' },
    { num: '100%',      label: 'Pflanzlich & Vegan' },
    { num: 'Made in',   label: 'Scotland, UK' }
  ],
  fr: [
    { num: '4,74/5',    label: 'Note moyenne' },
    { num: '604+',      label: 'Avis v\u00E9rifi\u00E9s' },
    { num: '2 000+',    label: 'Professionnels de sant\u00E9' },
    { num: '365 jours', label: 'Garantie satisfait ou rembours\u00E9' },
    { num: 'GMP',       label: 'Fabrication certifi\u00E9e' },
    { num: '100%',      label: 'V\u00E9g\u00E9tal & V\u00E9gan' },
    { num: 'Fabriqu\u00E9 en', label: '\u00C9cosse, UK' }
  ]
};

// ─── Video Testimonials ──────────────────────────────────────────────
BZ.VIDEOS = {
  general: [
    { src: 'https://cdn.shopify.com/videos/c/o/v/921883844620481bb30467eaf8450669.mp4' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/b1389e8135084d8692c17d30b1ee15c1.mp4' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/dc22b2f7aadb4a2dbf8ff0d9e6d00373.mp4' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/20df12e54e9f4ca3a14bbd5e2edbe068.mp4' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/b2ad20d2e95c4e6b8a9f8fb2c5c0d5e4.mp4' },
    { src: 'https://cdn.shopify.com/videos/c/o/v/6e5be76f53c74b62a90ca0e5e2da5c4f.mp4' }
  ]
};

// ─── Featured Reviews ────────────────────────────────────────────────
BZ.REVIEWS = {
  general: [],
  perimenopause: [],
  focus: [],
  calm: [],
  students: []
};

// ─── SVG Icons ────────────────────────────────────────────────────────
BZ.ICONS = {
  shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>',
  globe:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"/><path d="M2 12h20M12 2c2.5 2.5 4 6 4 10s-1.5 7.5-4 10c-2.5-2.5-4-6-4-10s1.5-7.5 4-10z"/></svg>',
  flag:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 21V4m0 0l2.5 1.5L9 4l2.5 1.5L14 4l2.5 1.5L19 4v9l-2.5 1.5L14 13l-2.5 1.5L9 13l-2.5 1.5L4 13"/></svg>',
  play:   '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>',
  star:   '\u2733\u2733\u2733\u2733\u2733'
};


/* ─────────────────────────────────────────────────────────────────────
   2. SHARED COMPONENTS  (from _shared/components.js)
   ───────────────────────────────────────────────────────────────────── */

(function() {
  'use strict';

  if (!window.BZ) {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.innerHTML = '<div style="max-width:600px;margin:80px auto;padding:20px;font-family:sans-serif;text-align:center;">' +
        '<h1 style="font-size:22px;margin-bottom:12px;">Page failed to load</h1>' +
        '<p>A required script did not load. Please refresh or check your connection.</p></div>';
    });
    return;
  }

  var C = window.LP_CONFIG || {};
  var market = BZ.MARKETS[C.market] || BZ.MARKETS.uk;
  var products = BZ.PRODUCTS[C.market] || BZ.PRODUCTS.uk;
  var lang = (market && market.lang) || 'en';
  var primary = (products && products[C.product]) || (products && products.elite) || {};
  var bundle = products && products.bundle;

  // ─── Helper ──────────────────────────────────────────────────────
  function esc(s) {
    if (s == null) return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  // ─── Component Registry ──────────────────────────────────────────
  var Components = {};

  // ── 1. Header — OMITTED: Shopify theme provides chrome ──
  // Components.header is intentionally not registered here.
  // The [data-component="header"] mount point is removed from the section body.

  // ── 2. Star Row ───────────────────────────────────────────────────
  Components.starRow = function() {
    var r = market.reviewStats || {};
    return '<div class="star-row">' +
      '<span>\u2733\u2733\u2733\u2733\u2733</span>' +
      '<span class="rating-text">' + esc(r.rating) + '/5 from ' + esc(r.count) + ' ' + esc(r.source) + '</span>' +
      '</div>';
  };

  // ── 3. Proof Strip ────────────────────────────────────────────────
  Components.proofStrip = function() {
    var items = market.proofStrip || [];
    return '<div class="proof-strip"><div class="container" style="display:flex;justify-content:center;gap:32px;flex-wrap:wrap;align-items:center;">' +
      items.map(function(item) { return '<span>' + item + '</span>'; }).join('') +
      '</div></div>';
  };

  // ── 4. Product Comparison Table ───────────────────────────────────
  Components.productTable = function(params) {
    var highlight = params.highlight || C.product || 'elite';
    var rows = ['original', 'pro', 'elite'];
    var headerLabel = { en: ['Product', 'Best For', 'Price'], de: ['Produkt', 'Am besten f\u00FCr', 'Preis'], fr: ['Produit', 'Id\u00E9al pour', 'Prix'] };
    var headers = headerLabel[lang] || headerLabel.en;

    var html = '<table class="product-table"><thead><tr>';
    headers.forEach(function(h) { html += '<th>' + esc(h) + '</th>'; });
    html += '</tr></thead><tbody>';

    rows.forEach(function(slug) {
      var p = products[slug];
      if (!p) return;
      var cls = slug === highlight ? 'active-highlight' : '';
      html += '<tr data-product="' + slug + '"' + (cls ? ' class="' + cls + '"' : '') + '>' +
        '<td>' + esc(p.shortName) + '</td>' +
        '<td>' + esc(p.purpose) + '</td>' +
        '<td>' + esc(p.price) + '</td>' +
        '</tr>';
    });

    html += '</tbody></table>';
    return html;
  };

  // ── 5. Bundle Box ─────────────────────────────────────────────────
  Components.bundleBox = function() {
    if (!bundle) return '';
    var bundleLabel = { en: 'Starter Bundle \u2014 All 3 Formulas', de: 'Starter-Set \u2014 Alle 3 Formeln', fr: 'Pack D\u00E9couverte \u2014 Les 3 formules' };
    var subLabel = { en: 'Subscribe & Save', de: 'Abonniere & Spare', fr: 'Abonnez-vous & \u00E9conomisez' };

    return '<div class="bundle-box">' +
      '<span class="bundle-label">' + esc(bundleLabel[lang] || bundleLabel.en) + '</span>' +
      '<p style="font-size:22px;font-weight:700;margin:12px 0 2px;">' + esc(bundle.name) + ': ' + esc(bundle.price) +
        ' <span style="font-size:14px;opacity:0.7;">(' + esc(bundle.saveLabel) + ')</span></p>' +
      '<p style="font-size:13px;opacity:0.8;margin:0;">' + esc(subLabel[lang] || subLabel.en) + ': ' + esc(bundle.priceSub) +
        ' (' + esc(bundle.subDiscount) + ')</p>' +
      '</div>';
  };

  // ── 6. Product CTA Buttons ────────────────────────────────────────
  Components.productCta = function(params) {
    var pSlug = params.primarySlug || C.product || 'elite';
    var sSlug = params.secondarySlug || 'bundle';
    var pProd = products[pSlug] || primary;
    var sProd = products[sSlug];
    if (!pProd) return '';
    var pLabel = params.primaryLabel || (({ en: 'Try ', de: 'Jetzt ', fr: 'Essayez ' })[lang] || 'Try ') + pProd.name + ' \u2014 ' + pProd.price;
    var sLabel = sProd ? (params.secondaryLabel || (({ en: 'Try the ', de: 'Zum ', fr: 'Essayez le ' })[lang] || 'Try the ') + sProd.name + ' \u2014 ' + sProd.price) : '';

    var pHref = pProd.cart || pProd.url;
    var sHref = sProd ? (sProd.cart || sProd.url) : '';
    return '<div style="margin-top:24px;">' +
      '<a href="' + esc(pHref) + '" class="btn btn-primary">' + esc(pLabel) + '</a>' +
      (sProd ? '<a href="' + esc(sHref) + '" class="btn btn-secondary">' + esc(sLabel) + '</a>' : '') +
      '</div>';
  };

  // ── 7. Video Testimonial Grid ─────────────────────────────────────
  Components.videoGrid = function(params) {
    var pool = params.pool || C.videos || 'general';
    var videos = BZ.VIDEOS[pool] || BZ.VIDEOS.general || [];
    if (!videos.length) return '';

    var html = '<div class="video-grid">';
    videos.forEach(function(v) {
      html += '<div class="video-card" role="button" tabindex="0">' +
        '<video src="' + esc(v.src) + '" loop playsinline preload="metadata" onerror="this.parentElement.style.display=\'none\'"></video>' +
        '<div class="play-btn">' + BZ.ICONS.play + '</div>' +
        '</div>';
    });
    html += '</div>';
    return html;
  };

  // ── 8. Trust Carousel ─────────────────────────────────────────────
  Components.trustCarousel = function() {
    var items = BZ.TRUST_CAROUSEL[lang] || BZ.TRUST_CAROUSEL.en;
    var html = '<div class="trust-carousel"><div class="trust-carousel-track">';
    for (var i = 0; i < 2; i++) {
      items.forEach(function(item) {
        html += '<div class="trust-item"><span class="trust-num">' + esc(item.num) + '</span><span class="trust-label">' + esc(item.label) + '</span></div>';
      });
    }
    html += '</div></div>';
    return html;
  };


  // ── 10. Sticky CTA Bar ────────────────────────────────────────────
  Components.stickyCtaBar = function(params) {
    var slug = params.product || C.product || 'elite';
    var prod = products[slug] || primary;
    if (!prod) return '';
    var label = params.label || (({ en: 'Try ', de: 'Jetzt ', fr: 'Essayez ' })[lang] || 'Try ') + prod.name;

    return '<div class="sticky-cta" id="stickyCta">' +
      '<a href="' + esc(prod.cart || prod.url) + '" id="stickyCtaLink">' + esc(label) + '</a>' +
      '</div>';
  };

  // ── 11. Footer — OMITTED: Shopify theme provides chrome ──
  // Components.footer is intentionally not registered here.
  // The [data-component="footer"] mount point is removed from the section body.

  // ── 12. Disclaimer ────────────────────────────────────────────────
  Components.disclaimer = function() {
    return '<div class="disclaimer">' + esc(market.disclaimer) + '</div>';
  };

  // ── 13. Progress Bar ─────────────────────────────────────────────
  Components.progressBar = function() {
    return '<div class="progress-bar" id="progressBar"></div>' +
      '<div class="progress-label" id="progressLabel"></div>';
  };

  // ─── Shared JS Functions ─────────────────────────────────────────
  BZ.toggleVideo = function(card) {
    var video = card.querySelector('video');
    var btn = card.querySelector('.play-btn');
    if (!video || !btn) return;
    if (video.paused) {
      document.querySelectorAll('.video-card video').forEach(function(v) {
        if (v !== video) {
          v.pause(); v.muted = true;
          var pb = v.parentElement && v.parentElement.querySelector('.play-btn');
          if (pb) pb.style.display = 'flex';
        }
      });
      video.muted = false;
      video.play().catch(function () { video.muted = true; video.play().catch(function () {}); });
      btn.style.display = 'none';
    } else {
      video.pause();
      btn.style.display = 'flex';
    }
  };


  BZ.initProgressBar = function() {
    var bar = document.getElementById('progressBar');
    var label = document.getElementById('progressLabel');
    var stickyCta = document.getElementById('stickyCta');
    if (!bar) return;
    if (bar.dataset.pbBound) return; bar.dataset.pbBound = '1';  // T-fecd05: same flag as bz-killer-core initProgress → core no-ops on UK (monolith owns the richer section-label + sticky-threshold progress)

    var sections = C.progressSections || [];
    var stickyThresholds = C.stickyThresholds || [];

    window.addEventListener('scroll', function() {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = pct + '%';

      if (label && sections.length) {
        var allSections = document.querySelectorAll('.section, .section-alt, .cta-section');
        var currentIdx = 0;
        allSections.forEach(function(sec, i) {
          if (sec.getBoundingClientRect().top <= 200) currentIdx = i;
        });
        if (currentIdx < sections.length) {
          label.textContent = sections[currentIdx];
          label.classList.add('visible');
        }
      }

      if (stickyCta) {
        if (pct > 5) {
          stickyCta.classList.add('visible');
        } else {
          stickyCta.classList.remove('visible');
        }
      }

      if (stickyCta && stickyThresholds.length) {
        var link = document.getElementById('stickyCtaLink');
        if (link) {
          var pctDec = pct / 100;
          for (var i = stickyThresholds.length - 1; i >= 0; i--) {
            if (pctDec >= stickyThresholds[i].threshold) {
              link.textContent = stickyThresholds[i].label;
              link.href = stickyThresholds[i].url;
              break;
            }
          }
        }
      }
    });
  };

  // ─── Auto-Render ─────────────────────────────────────────────────
  function renderComponents() {
    try {
      document.querySelectorAll('[data-component]').forEach(function(el) {
        var name = el.dataset.component;
        if (Components[name]) {
          try {
            var params = {};
            Array.prototype.forEach.call(el.attributes, function(attr) {
              if (attr.name.indexOf('data-') === 0 && attr.name !== 'data-component') {
                var key = attr.name.replace('data-', '').replace(/-([a-z])/g, function(m, c) { return c.toUpperCase(); });
                params[key] = attr.value;
              }
            });
            el.innerHTML = Components[name](params);
          } catch (err) {
            console.error('Component "' + name + '" failed:', err);
          }
        }
      });
    } catch (err) {
      console.error('Component render loop failed:', err);
    }

    BZ.initProgressBar();

    document.querySelectorAll('img:not([onerror])').forEach(function(img) {
      img.onerror = function() { this.style.display = 'none'; };
    });

    document.querySelectorAll('.video-card[role="button"]').forEach(function(card) {
      card.addEventListener('click', function() { BZ.toggleVideo(card); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); BZ.toggleVideo(card); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderComponents);
  } else {
    renderComponents();
  }

})();


/* ─────────────────────────────────────────────────────────────────────
   3. LP_CONFIG  (formerly inline script block 1, L414-L426)
   ───────────────────────────────────────────────────────────────────── */

window.LP_CONFIG = {
  market: 'uk',
  product: 'pro',
  discount: { code: 'WELCOME10', label: '10% off your first order' },
  discountCode: 'WELCOME10',
  pageType: 'blog-adhd',
  showDraftBanner: false,
  showComplianceBanner: false,
  videos: 'general',
  progressSections: ['Why You\u2019re Here', 'Does This Feel Familiar?', 'Where Nutrition Fits In', 'What Nutrition Can Do', 'Evidence', 'While You\u2019re Waiting', 'A Typical Day', 'What to Look For', 'Choose Your Formula', 'Real Stories', 'Plan Your Path', 'FAQ']
};




/* ─────────────────────────────────────────────────────────────────────
   5. PLAN YOUR PATH  (formerly inline script block 3, L1617-L1708)
   ───────────────────────────────────────────────────────────────────── */

(function(){
  // Tab switching
  var tabs = document.querySelectorAll('.planpath-tab');
  var panels = document.querySelectorAll('.planpath-panel');
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      var key = t.getAttribute('data-tab');
      tabs.forEach(function(x){ var on = x === t; x.classList.toggle('active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function(p){ p.classList.toggle('active', p.getAttribute('data-panel') === key); });
    });
  });

  // NHS lookup
  var NHS_DATA = {
    'london':       { range: '2&ndash;4 years', tip: 'London trusts are among the faster routes &mdash; some adults are seen within 18 months. Right to Choose can shorten this further.' },
    'south-east':   { range: '3&ndash;5 years', tip: 'Most South East trusts now route through Right to Choose providers. Expect faster results going private-NHS than direct local NHS.' },
    'south-west':   { range: '3&ndash;6 years', tip: 'Wait times in Devon and Cornwall are among the longest in England. Right to Choose to a national provider often cuts this significantly.' },
    'east-england': { range: '4&ndash;7 years', tip: 'East of England has reported some of the longest adult assessment waits. Right to Choose is widely used here to bypass local backlog.' },
    'east-mids':    { range: '3&ndash;6 years', tip: 'Nottinghamshire and Leicestershire have improving but still long waits. Right to Choose is the typical route to faster assessment.' },
    'west-mids':    { range: '3&ndash;6 years', tip: 'Birmingham and surrounding trusts are heavily backlogged. Right to Choose providers usually offer the fastest legitimate route.' },
    'yorkshire':    { range: '3&ndash;6 years', tip: 'Yorkshire trusts have variable waits. Sheffield tends to be faster than Leeds or Bradford. Right to Choose remains your fastest legitimate option.' },
    'north-east':   { range: '2&ndash;5 years', tip: 'North East waits have improved with extra commissioning. Local NHS is sometimes faster here than going via Right to Choose.' },
    'north-west':   { range: '4&ndash;7 years', tip: 'Manchester and Merseyside have reported very long waits. Right to Choose is widely used to access faster, NHS-funded private assessment.' },
    'scotland':     { range: '1&ndash;3 years', tip: 'Scotland\u2019s ADHD pathway is shorter on average than England\u2019s but varies by health board. Right to Choose does not apply &mdash; speak to your GP about NHS or self-funded options.' },
    'wales':        { range: '2&ndash;4 years', tip: 'Welsh ADHD services are devolved &mdash; ask your GP about local NHS Wales waits and any private referral options.' },
    'ni':           { range: '2&ndash;5 years', tip: 'Northern Ireland\u2019s ADHD service is delivered through HSC trusts. Waits vary widely &mdash; ask your GP what\u2019s realistic in your trust area.' }
  };
  var sel = document.getElementById('ppNhsRegion');
  var res = document.getElementById('ppNhsResult');
  var rng = document.getElementById('ppNhsRange');
  var tip = document.getElementById('ppNhsTip');
  if (sel) {
    sel.addEventListener('change', function(){
      var d = NHS_DATA[sel.value];
      if (!d) { res.classList.remove('visible'); return; }
      rng.innerHTML = d.range;
      tip.innerHTML = d.tip;
      res.classList.add('visible');
    });
  }

  // Formula quiz \u2014 stepper
  var FORMULA = {
    original: { name: 'FOCUS ORIGINAL\u2122', blurb: 'The gentlest of the three. 12 active ingredients. Right for first-time supplement users or anyone wanting steady, mild everyday support.', cta: 'Try FOCUS ORIGINAL \u2014 \u00A318', url: '/products/brainzyme-original-milder-formula' },
    pro:      { name: 'FOCUS PRO\u2122',      blurb: 'Our strongest everyday focus formula. 20 active ingredients including studied botanicals, B-complex, zinc and magnesium. Right for demanding workdays.', cta: 'Try FOCUS PRO \u2014 \u00A329',      url: '/products/brainzyme-professional-stronger-formula' },
    elite:    { name: 'FOCUS ELITE\u2122',    blurb: 'Our most complete formula. 29 active ingredients adding GABA precursors, gut-brain nutrients and mood-support botanicals. Right when stress is part of the picture.', cta: 'Try FOCUS ELITE \u2014 \u00A347',    url: '/products/brainzyme-elite' }
  };

  (function() {
    var stepper = document.getElementById('ppQuizStepper');
    if (!stepper) return;
    var track = document.getElementById('ppQuizTrack');
    var currentStep = 0;
    var votes = {};

    function goToSlide(n) {
      currentStep = n;
      track.querySelectorAll('.pp-quiz-slide').forEach(function(s) {
        var step = parseInt(s.getAttribute('data-step'), 10);
        var isTarget = (step === n + 1);
        if (isTarget) s.style.display = '';
        s.classList.toggle('active', isTarget);
      });
      if (n >= 3) showResult();
    }

    function showResult() {
      var score = { original: 0, pro: 0, elite: 0 };
      Object.keys(votes).forEach(function(k) { score[votes[k]]++; });
      var winner = 'pro'; // tie-break: elite > pro > original (premium product wins ties)
      if (score.elite >= score.pro && score.elite >= score.original) winner = 'elite';
      else if (score.original >= score.pro) winner = 'original';
      var f = FORMULA[winner];
      document.getElementById('ppQuizName').textContent = f.name;
      document.getElementById('ppQuizBlurb').textContent = f.blurb;
      var cta = document.getElementById('ppQuizCta');
      cta.textContent = f.cta;
      // Prefer the page's own data-url (bz-planpath-tabs-* snippet, elite_url render
      // param) over the baked default - lets a page with an in-page buy form pass a
      // hash anchor while every other page falls back to the PDP (52E-2 2026-08-20).
      var domUrl = null;
      var domDiv = document.querySelector('.pp-quiz-formulas [data-formula="' + winner + '"]');
      if (domDiv && domDiv.dataset && domDiv.dataset.url) domUrl = domDiv.dataset.url;
      cta.href = domUrl || f.url;
    }

    goToSlide(0);

    var advancing = false;
    stepper.querySelectorAll('input[type="radio"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        stepper.querySelectorAll('input[name="' + radio.name + '"]').forEach(function(r) {
          var opt = r.closest('.pp-quiz-option'); if (opt) opt.classList.toggle('selected', r.checked);
        });
        votes[radio.name] = radio.value;
        var slide = radio.closest('.pp-quiz-slide'); var targetSlide = slide ? parseInt(slide.getAttribute('data-step'), 10) : 0;
        if (!advancing) {
          advancing = true;
          setTimeout(function() { advancing = false; goToSlide(targetSlide); }, 280);
        }
      });
    });

    var resetBtn = document.getElementById('ppQuizReset');
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        votes = {};
        currentStep = 0;
        stepper.querySelectorAll('input[type="radio"]').forEach(function(r) {
          r.checked = false;
          var opt = r.closest('.pp-quiz-option'); if (opt) opt.classList.remove('selected');
        });
        var resultSlide = document.getElementById('ppQuizResult');
        if (resultSlide) resultSlide.style.display = 'none';
        goToSlide(0);
      });
    }
  })();
})();


/* ─────────────────────────────────────────────────────────────────────
   6. PAGE INTERACTIONS  (formerly inline script block 4, L1797-L2093)
   ───────────────────────────────────────────────────────────────────── */





// === Dynamic Sticky Smart CTA ===
(function() {
  var cta = document.getElementById('stickyCta');
  var ctaText = document.getElementById('stickyCtaText');
  var ctaLink = document.getElementById('stickyCtaLink');
  if (!cta) return;
  var productUrl = 'https://brainzyme.myshopify.com/cart/31430904086606:1';
  var messages = [
    {threshold: 0.05, text: 'Keep reading', label: 'Learn more', url: '#shelfGrid'},
    {threshold: 0.20, text: 'Honest science, no hype', label: 'See what works', url: '#shelfGrid'},
    {threshold: 0.40, text: 'A legitimate option while you wait', label: 'How FOCUS PRO helps', url: '#shelfGrid'},
    {threshold: 0.60, text: '365-day money-back guarantee', label: 'Try FOCUS PRO risk-free', url: '#shelfGrid'},
    {threshold: 0.80, text: '6,020+ verified reviews', label: 'Try FOCUS PRO \u2014 \u00A329', url: '#shelfGrid'}
  ];
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) { ticking = true; requestAnimationFrame(function() {
      var pct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      cta.classList.toggle('visible', pct > 0.1 && pct < 0.95);
      var msg = messages[0];
      for (var i = messages.length - 1; i >= 0; i--) { if (pct >= messages[i].threshold) { msg = messages[i]; break; } }
      ctaText.textContent = msg.text;
      ctaLink.textContent = msg.label;
      if (msg.url !== '#') ctaLink.href = msg.url;
      ticking = false;
    }); }
  }, {passive: true});
})();



